import "./dot.scss";

type MenuDotProps = {
  critical: boolean;
};

export const MenuDot: React.FC<MenuDotProps> = ({ critical }) => {
  return <div className={`dot ${critical ? "critical" : ""}`} />;
};
